import * as React from "react";
import type { SVGProps } from "react";
const SvgChildSeatHighChair = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.96 11.71s-.02-.03-.03-.05c-.02-.07-.06-.12-.1-.18-.03-.05-.06-.1-.1-.15s-.1-.08-.15-.12a.8.8 0 0 0-.15-.1c-.06-.03-.12-.04-.19-.06-.06-.02-.12-.03-.19-.04-.02 0-.04-.01-.06-.01h-1V9h4c.55 0 1-.45 1-1s-.45-1-1-1H7.72l-.73-5.14a1 1 0 0 0-1.98.28l1 7v.02c.05 1.34.77 2.52 1.83 3.2l-2.8 9.35c-.16.53.14 1.09.67 1.25a1.005 1.005 0 0 0 1.25-.67l.99-3.3s.03.01.05.01h8s.03 0 .05-.01l.99 3.3a1.005 1.005 0 0 0 1.25.67c.53-.16.83-.72.67-1.25zM12 9v2h-2c-1.1 0-2-.9-2-2zm-3.46 8 1.21-4.03c.08 0 .16.03.25.03h4.26l1.2 4z"
    />
  </svg>
);
export default SvgChildSeatHighChair;
